import { render, staticRenderFns } from "./St52QuotaList.vue?vue&type=template&id=4e264be9&scoped=true&"
import script from "./St52QuotaList.vue?vue&type=script&lang=js&"
export * from "./St52QuotaList.vue?vue&type=script&lang=js&"
import style0 from "./St52QuotaList.vue?vue&type=style&index=0&id=4e264be9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e264be9",
  null
  
)

export default component.exports